module.exports = __webpack_public_path__ + "img/book-07.a8aeb920.png";